import "babel-polyfill";
import Es6Promise from "es6-promise";
Es6Promise.polyfill();
import "es6-promise/auto";
import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import ViService from "@/services/ViService";
import store from "./store";
import VueCryptojs from "vue-cryptojs";
import {
  BootstrapVue,
  BootstrapVueIcons,
  PaginationPlugin,
} from "bootstrap-vue";
import Icon from "vue-awesome/components/Icon";
import Toasted from "vue-toasted";
import VueMeta from "vue-meta";
import VueApexCharts from "vue-apexcharts";

import {
  dateFilter,
  dateFormatFilter,
  dateAndTimeFormatFilter,
  currencyDecimalFilter,
} from "./configuration/filter";

import scrollSpy, { Easing } from "vue2-scrollspy";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap-vue/dist/bootstrap-vue-icons.min.css";
import "../src/assets/css/v-select.css";
import "../src/assets/css/style.css";
import "../src/assets/css/animate.css";
import "../src/assets/css/loginStyles.css";
import "../src/assets/js/animatewow.js";
import "../src/assets/js/main.js";
import "../src/assets/css/adminstyles.css";
import "../src/assets/css/restable.css";
import secureUI from "@/utils/secureUI";
import * as VeeValidate from "vee-validate";
import * as VueGoogleMaps from "vue2-google-maps";
import TurnOffAutocomplete from "vue-turn-off-autocomplete";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyA0VSaHmsUM8If8jEipJAYJ66js87WD4Co",
  },
  installComponents: true,
});

Vue.config.productionTip = false;
Vue.component("v-icon", Icon);
Vue.use(TurnOffAutocomplete);
Vue.use(VueCryptojs);
Vue.use(VeeValidate);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(PaginationPlugin);
Vue.use(VueApexCharts);
Vue.use(scrollSpy, {
  easing: Easing.Cubic.In,
});

Vue.filter("date", dateFilter);
Vue.filter("dateFormat", dateFormatFilter);
Vue.filter("currencyFormat", currencyDecimalFilter);
Vue.filter("dateAndTimeFormat", dateAndTimeFormatFilter);

let toastOptions = {
  theme: "outline",
  position: "top-center",
  duration: 2000,
  action: [
    {
      text: "Ok",
      onClick: (e, toastObject) => {
        toastObject.goAway(0);
      },
    },
  ],
  className: "viToast shadow",
};
Vue.use(Toasted, toastOptions);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});
Vue.component("v-icon", Icon);
Vue.component("apexchart", VueApexCharts);

new Vue({
  router,
  store,
  render: (h) => h(App),
  created() {
    this.initialMethod();
  },
  methods: {
    async initialMethod() {
      try {

      var url = window.location.href;
      var lg = new URL(url).searchParams.get("logout");
      // Output the value of the token parameter to the console
      if( lg != undefined ) {
        this.logout();
      } else {
        let userData = secureUI.sessionGet("user");

        if (userData) {
          const response = await ViService.viXGet(
            "/auth/authenticate",
            userData.token
          );

          if (response.success) {
            const validateResponse = await ViService.viXGet(
              `/auth/validate/authenticate?email=${response.data.user.userName}`,
              userData.token
            );

            if (validateResponse.isSuccess) {
              const pathName = window.location.pathname;
              this.$store.dispatch(
                "setUserDetail",
                validateResponse.data.userDetails
              );

              if (userData.userDetails.profile.name == "School Admin") {
                this.$store.dispatch(
                  "setCurrentPlanDetail",
                  validateResponse.data.subscription
                );
              }

              if (pathName === "/" || pathName === "/home") {
                const appUrl = 'https://admin--stage.vidhyaan.com'
                

            
                if (userData.userDetails.profile.name == "School Admin") {
                  if (userData.userDetails.account.version == "freeVersion") {
                    localStorage.setItem("activeTab", "/enrollment/school");
                    window.location.href = appUrl + `?token=${encodeURIComponent( localStorage.getItem("user") ).trim()}`;
                    // window.location.href = appUrl + '/enrollment/school' + `?token=${encodeURIComponent( localStorage.getItem("user") ).trim()}`;
                  } else {
                    if (
                      validateResponse.data.subscription.status == "dunning" ||
                      validateResponse.data.subscription.status == "unpaid" ||
                      validateResponse.data.subscription.status == "cancelled"
                    ) {
                      localStorage.setItem(
                        "activeTab",
                        "/admission/admissionSettings"
                      );
                      // window.location.href = appUrl + '/admission/admissionSettings' + `?token=${encodeURIComponent( localStorage.getItem("user") ).trim()}`;
                    } else {
                      localStorage.setItem("activeTab", "/admission/home");
                      // window.location.href = appUrl + '/admission/home' + `?token=${encodeURIComponent( localStorage.getItem("user") ).trim()}`;
                    }
                    window.location.href = appUrl + `?token=${encodeURIComponent( localStorage.getItem("user") ).trim()}`;
                  }
                } else if (
                  userData.userDetails.profile.name == "Vidhyaan Admin"
                ) {
                  localStorage.setItem("activeTab", "/admin-panel");
                  window.location.href = appUrl + `?token=${encodeURIComponent( localStorage.getItem("user") ).trim()}`;
                  // window.location.href = appUrl + '/admin-panel' + `?token=${encodeURIComponent( localStorage.getItem("user") ).trim()}`;
                } else {
                  if (userData.userDetails.isShowStudentProfile) {
                    this.getStudentAndSchoolInfo();
                  } else {
                    localStorage.setItem("activeTab", "/parent/search/home");
                    window.location.href = appUrl + `?token=${encodeURIComponent( localStorage.getItem("user") ).trim()}`;
                    // window.location.href = appUrl + '/parent/search/home' + `?token=${encodeURIComponent( localStorage.getItem("user") ).trim()}`;
                  }
                }
              }
            } else {
              localStorage.removeItem("user");
              this.$router.push("/login");
            }
          } else {
            localStorage.removeItem("user");
            this.$router.push("/login");
          }
        } else {
          const pathName = window.location.pathname;
          if (
            pathName != "/" &&
            pathName != "/change-password" &&
            pathName != "/admin-panel" &&
            pathName != "/invitaion-accept" &&
            pathName != "/paymentConfirmation" &&
            pathName != "/search-school/overview" &&
            this.$route.fullPath != "/#whyvidhyaan" &&
            pathName != "/pricingView"
          ) {
            this.$router.push({
              name: "home",
            });
          }
        }
      }
    } catch (err) {
      localStorage.removeItem('user');
      localStorage.removeItem('superAdminuser');
    //  localStorage.removeItem('user');

      console.log("in catch error ==> ", err);
    }
    },
    logout() {
      let userData = secureUI.sessionGet("user");

      if( userData ) {
        ViService.viPost("/auth/logout", {_id: userData.userDetails._id })
          .then((res) => {
            if (res.isSuccess) {
              this.$store.dispatch("setIndividualSchoolInfo",{});
              this.$store.dispatch("setCurrentPlanDetail",{});
              this.$store.dispatch('setOurServiceActiveLink', '');
              this.$store.dispatch('setUserDetail', {});

              this.$store.dispatch("setAdmissionObjCOunt",{
                academicYear: 0,
                admission: 0,
                class: 0,
                departMent: 0,
                student: 0,
                teacher: 0,
                schoolType: 0,
                admins: 0,
                section: 0,
                subject: 0

              });
              this.$store.dispatch("setEnrollObjCOunt",{
        
                academicYear: 0,
                admission: 0,
                class: 0,
                onlineAdmission: 0,
                isVerified: false
              });
              this.$store.dispatch("setFeesManagementObjCount",{
                feeType : 0,
                feesPlan : 0,
                adhocFees : 0,
                assignedFeesType : 0,
                discountsAndPenalties : 0,
                feesPlanGenerated: 0
              });
                this.$store.dispatch('setFetchAdmissionObjCount',false)
              this.$store.dispatch("setFetchFeesObjCount",false);
              this.$store.dispatch("setFetchEnrollObjCount",false);
            
              localStorage.removeItem('user');
              localStorage.removeItem('superAdminuser');
              window.location.href = process.env.VUE_APP_REDIRECT_URL;
            } else {
            this.$toasted.error(res.message);
            }
          })
          .catch((e) => {
          
            this.$toasted.error(eData);
          });
      } else {
        this.$router.replace('/')
      }
   },
    getStudentAndSchoolInfo() {
      let userData = secureUI.sessionGet("user");

      ViService.viXGet(
        "/contact/getStudentAndSchoolDetails/parent/portal",
        userData.token
      )
        .then((res) => {
          if (res.isSuccess) {
            let data = secureUI.secureGet(res.data);

            if (res.data) {
              const appUrl = 'https://admin--stage.vidhyaan.com'

              const studentInformationDetails = data;
              const studentProfiles = studentInformationDetails.filter(
                (x) => x.type == "Contact"
              );
              this.studentInformation = studentProfiles[0];

              localStorage.setItem(
                "activeTab",
                `/parent/student/home/${this.studentInformation._id}`
              );
              window.location.href = appUrl + `?token=${encodeURIComponent( localStorage.getItem("user") ).trim()}`;

            //  window.location.href = appUrl + '/parent/search/home' + `?token=${encodeURIComponent( localStorage.getItem("user") )}`;
            }
          } else {
            this.$toasted.show(res.message);
          }
        })
        .catch((e) => {
          let eData = errorLog.apiErrorLog(e);
          this.$toasted.error(eData);
        });
    },
  },
}).$mount("#app");
